import React from 'react';

import {
  Box,
  Typography,
  TypographyVariant,
} from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const NoResults = ({
  variant,
  text = 'No results found',
  icon = <SearchOffIcon />,
}: {
  variant?: TypographyVariant;
  text?: string;
  icon?: React.ReactNode;
}) => (
  <Box sx={{
    padding: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  }}
  >
    {icon}
    <Typography variant={variant}>
      {text}
    </Typography>
  </Box>
);

export default NoResults;
